<template>
<div>
    <section>
    <div class="div-block-2176">
      <a href="#" class="w-inline-block"><img loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" class="image-654"></a>
    </div>
  </section>
  <section>
    <div class="reviewsection_wrap">
      <div class="review_maindiv">
        <div class="review_div">
          <div class="div-block-2187"><img src="@/assets/images/emoji_stress.webp" loading="lazy" alt="" class="image-659"></div>
          <div class="text-block-1614-copy with-sub">We’re Sorry — And Already Working On It</div>
          <p class="paragraph-209-copy after">We’ve have your feedback and already notified our Patient Care Management Team.<br><br>We’re sorry your experience wasn’t what you expected, and we want to make it right.<br><br>We will reach out to you as fast as possible to understand what happened and help resolve the issue.<br><br>Thank you for giving us the opportunity to fix this.</p>
          <div class="text-block-1614-copy2-copy">If this is urgent, please click here to call us.</div>
          <a :href="'tel:' + phoneNumber" class="button-168 w-button">Call Now *</a>
          <p class="paragraph-209-copy-copy">*<em>If within normal business hours.</em></p>
        </div>
      </div>
    </div>
  </section>
    <div style="height: 100px;"></div>
</div>
</template>

<script>
export default {
    name: 'ReviewThanksBad',
    computed: {
        phoneNumber() {
            return process.env.VUE_APP_PHONE || '';
        }
    }
}
</script>

<style scoped>
</style>

